import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FlatProgram, Program } from 'src/app/models/program';
import { ProgramsService } from 'src/app/services/programs.service';
import { WaitIndicatorService } from 'src/app/services/wait-indicator.service';

@Component({
    selector: 'app-info-program',
    templateUrl: './info-program.component.html',
    styleUrls: ['./info-program.component.scss']
})
export class InfoProgramComponent {
    private _program?: Program;
    protected programs: FlatProgram[] = [];

    public get program(): Program | undefined {
        return this._program;
    }
    @Input()
    public set program(v: Program | undefined) {
        this._program = v;
        if (this.program?.id) {
            this.flattenProgram(this.program?.id);
        }
    }

    @Output()
    public done = new EventEmitter();

    public constructor(
        private programService: ProgramsService,
        private wait: WaitIndicatorService,
    ) { }

    private flattenProgram = async (id: string): Promise<void> => {
        this.wait.show();
        const program = await this.programService.byId(id);
        if (program == null) return;

        const result: FlatProgram[] = [];
        for (const period of program.periods) {
            if (period.package) {
                result.push({
                    name: program.name,
                    winter: program.winter,
                    product: period.product?.name ?? '',
                    sport: period.sports.map(s => s.name).join(', '),
                    level: period.levels.map(l => l.name).join(', '),
                    date: period.dates[0],
                    description: period.description,
                    minAge: period.ageRange.lower,
                    maxAge: period.ageRange.upper,
                    duration: period.packageDuration,
                    capacity: period.capacity,
                    price: period.price
                });
            } else {
                for (const date of period.dates) {
                    result.push({
                        name: program.name,
                        winter: program.winter,
                        product: period.product?.name ?? '',
                        sport: period.sports.map(s => s.name).join(', '),
                        level: period.levels.map(l => l.name).join(', '),
                        date: date,
                        description: '',
                        minAge: period.ageRange.lower,
                        maxAge: period.ageRange.upper,
                        duration: period.packageDuration,
                        capacity: period.capacity,
                        price: period.price
                    });
                }
            }
        };
        this.wait.hide();
        this.programs = result.sort((a: FlatProgram, b: FlatProgram) => a.date.getTime() - b.date.getTime());
    }
}
